/**
 * ArtifactSummary — summary section container of the artifact detail page.
 *
 * Redux-connected: selects the mapped ArtifactDetailView from the artifactDetail
 * slice and composes the pure leaves (status line, headline identifiers +
 * artifactDetails document, tags). Renders nothing until an artifact is loaded.
 */
import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useAppSelector } from 'src/store/hooks';
import { CorrelationTags } from '../../paymentDetails/summary/CorrelationTags';
import { ArtifactStatusLine } from './ArtifactStatusLine';
import { ArtifactDetailsView } from './ArtifactDetailsView';

export const ArtifactSummary = () => {
  const detail = useAppSelector(state => state.artifactDetail.data);
  if (!detail) return null;

  return (
    <Container>
      <SpaceBetween size="m">
        <ArtifactStatusLine
          id={detail.id}
          statusLabel={detail.statusLabel}
          statusType={detail.statusType}
          locationBadge={detail.locationBadge}
        />
        <ArtifactDetailsView detail={detail} />
        <CorrelationTags tags={detail.correlationTags} />
      </SpaceBetween>
    </Container>
  );
};
